import { UseMutationOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  ExportFrameworksMutation,
  ExportFrameworksMutationVariables,
} from "../../../generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../useGraphQlClient";

const exportFrameworks = graphql(`
  mutation exportFrameworks(
    $filters: SearchFrameworksRequest!
    $exportFormat: ExportFormatArgs!
    $selectedFrameworks: SelectedFrameworks!
    $selectedFields: [String!]
  ) {
    exportFrameworks(
      SearchFrameworksRequest: $filters
      ExportFormat: $exportFormat
      SelectedFrameworks: $selectedFrameworks
      SelectedFields: $selectedFields
    ) {
      id
    }
  }
`);

export function useFrameworksExport(
  options?: UseMutationOptions<
    ExportFrameworksMutation,
    unknown,
    ExportFrameworksMutationVariables,
    unknown
  >,
) {
  const { data, ...rest } = useGraphQlMutation(exportFrameworks, options);
  return { ...rest, data: data?.exportFrameworks };
}
